import primaryButtonAccentDefault from '../../../../../common/algorithms/primary-button-accent-default';

const secondary = (params) => primaryButtonAccentDefault(params);

export default secondary;
